module.exports = __webpack_public_path__ + "img/substitute.5ecc62f7.svg";